<template>
  <div class="label-question u-row u-center u-middle">
    <div class="label-question__text u-full-width">
      {{ text }}
    </div>
  </div>
</template>

<script>
import Object3d from '@/plugins/Dom3d/mixin'

export default {
  mixins: [Object3d],

  props: {
    text: {
      type: String,
      default: ''
    }
  }
}  
</script>

<style lang="stylus">
@import '~@/styles/settings/variables'

.label-question
  height 200px
  width 1200px !important

  &__text
    font-size 50px
    font-family cody
    text-shadow $colors.black 2px 1px 2px
</style>